import { httpRequest } from '@calendly/http-tools'

export const EMAIL_PROVIDER_LOADING = 'EMAIL_PROVIDER_LOADING'
export const EMAIL_PROVIDER_SUCCESS = 'EMAIL_PROVIDER_SUCCESS'
export const EMAIL_PROVIDER_REJECTED = 'EMAIL_PROVIDER_REJECTED'

export const BUCKETS = {
  GOOGLE: 'google',
  MICROSOFT: 'microsoft',
  GMAIL: 'gmail',
}

const BUCKET_MAP = {
  [BUCKETS.GMAIL]: BUCKETS.GOOGLE,
  [BUCKETS.GOOGLE]: BUCKETS.GOOGLE,
  [BUCKETS.MICROSOFT]: BUCKETS.MICROSOFT,
}

const emailProviderLoading = () => ({
  type: EMAIL_PROVIDER_LOADING
})

const emailProviderSuccess = (provider) => ({
  type: EMAIL_PROVIDER_SUCCESS,
  payload: provider
})

const emailProviderRejected = (error) => ({
  type: EMAIL_PROVIDER_REJECTED,
  payload: error
})

export const fetchEmailProvider = (email) => async (dispatch, getState) => {
  if (!email) {
    // should not happen as this fetch is only called if there is an email
    dispatch(emailProviderRejected())
    return
  }
  const state = getState()
  const { loading, settled } = state.emailProvider

  // this http request should only be called once
  if (loading || settled) {
    return
  }

  // make sure we update loading before calling the http request to prevent race condition due to re-renders
  dispatch(emailProviderLoading())
  try {
    const [success, data] = await httpRequest({
      url: `/api/booking/email_providers?email=${email}`,
      method: 'GET'
    })
    if (success && data?.bucket && Object.values(BUCKETS).includes(data.bucket)) {
      dispatch(emailProviderSuccess(BUCKET_MAP[data.bucket]))
    } else {
      dispatch(emailProviderSuccess(null))
    }
  } catch (error) {
    dispatch(emailProviderRejected(error))
  }
}
